// {Componente}{Verbo}{Acción}

export const SEND_WHATSAPP_POST_REQUEST = 'SEND_WHATSAPP_POST_REQUEST';
export const SEND_WHATSAPP_POST_SUCCESS = 'SEND_WHATSAPP_POST_SUCCESS';
export const SEND_WHATSAPP_POST_ERROR = 'SEND_WHATSAPP_POST_ERROR';
